import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import Wallet from "@/pages/wallet/Wallet";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/wallet/")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<Wallet />
		</DashboardLayout>
	);
}
